import { render, staticRenderFns } from "./RouteAvailableOrders.vue?vue&type=template&id=207bd2a4&scoped=true&"
import script from "./RouteAvailableOrders.vue?vue&type=script&lang=ts&"
export * from "./RouteAvailableOrders.vue?vue&type=script&lang=ts&"
import style0 from "./RouteAvailableOrders.vue?vue&type=style&index=0&id=207bd2a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207bd2a4",
  null
  
)

export default component.exports